// extracted by mini-css-extract-plugin
export default {"header":"styles_header__Sr61T","nav":"styles_nav__q0HbT","button":"styles_button__5fZ+Y","plus":"styles_plus__fBJtR","button-active":"styles_button-active__q525q"};